<!--
 * @Description:
 * @Author: xz
 * @Date: 2023-11-14 15:16:33
 * @LastEditTime: 2024-04-18 15:46:15
 * @LastEditors: xz
-->
<template>
  <div id="app">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <!-- v-show="searchView" -->
    <div class="searchClass" v-if="false">
      <div class="searchInfoClass">
        <div class="searchInfoItemClass">
          <div style="margin-right: 10px; width: 80px">作者:</div>
          <input placeholder="请输入搜索信息" class="searchInput" v-model="person" />
        </div>
        <div class="searchInfoItemClass">
          <div style="margin-right: 10px; width: 80px">主题:</div>
          <input placeholder="请输入搜索信息" class="searchInput" v-model="book" />
        </div>
        <div class="searchInfoItemClass">
          <div style="margin-right: 10px; width: 80px">时间:</div>
          <input placeholder="请输入搜索信息" class="searchInput" v-model="year" />
        </div>
        <div class="searchInfoItemClass">
          <div style="margin-right: 10px; width: 80px">关键字:</div>
          <input placeholder="请输入搜索信息" class="searchInput" v-model="gjz" />
        </div>
        <div class="searchInfoItemClass">
          <div style="margin-right: 10px; width: 80px">引文:</div>
          <input placeholder="请输入搜索信息" class="searchInput" v-model="company" />
        </div>
        <div class="searchInfoItemClass">
          <div style="margin-right: 10px; width: 80px">来源:</div>
          <input placeholder="请输入搜索信息" class="searchInput" v-model="literature" />
        </div>
        <div class="searchInfoItemClass">
          <div style="margin-right: 10px; width: 80px">全文检索:</div>
          <input v-model="keyword" placeholder="请输入搜索信息" class="searchInput" />
        </div>
        <div style="display: flex">
          <div @click="searchBook1" class="searchBtnClass">
            <i class="el-icon-search" style="margin-right: 5px"></i>搜索
          </div>
        </div>
      </div>
    </div>
    <div class="contente" v-if="false">
      <router-view />
    </div>
    <div>
      <el-dialog :title="title" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
        <el-form :model="user" ref="refRuleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="旧密码" prop="roleName">
            <el-input v-model="user.c_mobile" show-password></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="roleName">
            <el-input v-model="user.c_password" show-password></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisibleConfirm">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import userapi from "@/api/user";
import { redirectTo } from "@reach/router";
import md5 from "js-md5";

// import Tupu from "@/components/charts/tupu.vue";
export default {
  components: {
    // Pie,
    // Tupu,
  },
  name: "App",
  data() {
    const basePathUrl = window.basePathUrl || "";
    return {
      totoken: false,
      title: "修改密码",
      user: {
        c_name: "",
        c_mobile: "",
        c_password: "",
      },
      dialogVisible: false,
      menuListPhone: false,
      booksum: 0,
      bookTableList: [],
      iframeShow: false,
      searchResult: false,
      pageSize: 20,
      page: 1,
      pagecount: 0,
      keyword: "",
      showTu: false,
      fileUrl: "",
      searchView: false,
      drawer: false,
      drawerUrl: "",
      showCharts: false,
      showTilte: true,
      person: "",
      book: "",
      year: "",
      company: "",
      literature: "",
      journal: "",
      gjz: "",
      seword: "",
    };
  },
  mounted() {
    if (window.innerWidth && window.innerWidth > 1100) {
      this.menuListPhone = false;
    } else if (window.innerWidth < 1100) {
      this.menuListPhone = true;
    }
    //
    // this.$router.push({ path: '/' })
  },
  updated() {
    userapi.getUserByToken().then((res) => {
      if (res.data.code === 200 && res.data.data.c_role === "1") {
        this.totoken = true;
      }
    });
  },
  methods: {
    // 手机端选中菜单
    handleCommand(data) {
      switch (data) {
        case "home":
          this.gomain();
          break;
        case "check":
          this.infoSearch();
          break;
        case "map":
          this.goTupu();
          break;
        case "img":
          this.goSearch();
          break;
        case "float":
          this.goFloat();
          break;
        case "news":
          this.flyTolabel();
          break;
        case "admin":
          this.flyToPile();
          break;
        case "yonghu":
          this.goyonghu();
          break;
        default:
          break;
      }
    },
    goDe() {
      this.searchResult = false;
    },
    goFlow() {
      this.searchView = false;
      this.iframeShow = false;
      this.searchView = false;
      this.searchResult = false;

      this.$router.push(`/flowcount`);
    },
    goSearch() {
      this.searchView = false;
      this.iframeShow = false;
      this.searchView = false;
      this.searchResult = false;

      this.$router.push(`/search`);
    },
    goFloat() {
      this.searchView = false;
      this.iframeShow = false;
      this.searchView = false;
      this.searchResult = false;

      this.$router.push(`/float`);
    },
    flyTolabel() {
      // window.location.href = "http://192.168.0.52:8080/";
      window.open("http://122.152.198.146:9991/");
    },
    goTupu() {
      this.searchView = false;
      this.iframeShow = false;
      this.searchView = false;
      this.searchResult = false;

      this.$router.push(`/tupu`);
    },
    goyonghu() {
      this.searchView = false;
      this.iframeShow = false;
      this.searchView = false;
      this.searchResult = false;

      this.$router.push(`/yonghu`);
    },
    goreport() {
      this.searchView = false;
      this.iframeShow = false;
      this.searchView = false;
      this.searchResult = false;

      this.$router.push(`/Report`);
    },
    preViewBook(row) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      userapi
        .getRequest("/search/dealBook", {
          keyword: this.seword,
          fileurl: row.bookurl,
        })
        .then((res) => {
          loading.close();
          this.fileUrl = res.data.replace(
            "/home/tscon/we/mcc/",
            "https://edam.tscon.cn:7778/"
          );
          this.iframeShow = true;
          this.showCharts = false;
        });
    },
    infoSearch() {
      // this.searchView = !this.searchView;
      this.$router.push(
        `/de?keyword=` +
        this.keyword +
        `&person=` +
        this.person +
        `&book=` +
        this.book +
        `&year=` +
        this.year +
        `&gjz=` +
        this.gjz +
        `&company=` +
        this.company +
        `&literature=` +
        this.literature
      );
    },
    gomain() {
      this.searchView = false;
      this.iframeShow = false;
      this.searchView = false;

      this.$router.push(`/`);
    },
    flyToPile() {
      window.location.href = "http://edam.tscon.cn:7777/mcc/kmap_admin/";

      // this.showTilte = false;
      // const { map } = this;
      // this.stopRotate();
      // // {"lat":29.755889,"lng":102.189752,"alt":4211,"heading":115,"pitch":-36}
      // let extent = {
      //   // 矩形视角经度范围
      //   // longitude: 102.21411063476563,latitude: 29.747483173153242,
      //   xmin: 95.025795,
      //   xmax: 95.027795,
      //   // 矩形视角纬102.2158度范围
      //   ymin: 29.8033142117,
      //   ymax: 29.8053142117,
      //   // 视角高度
      //   height: 60000,
      // };
      // let options = {
      //   duration: 5,
      //   // 视角旋转角度
      //   pitch: -90,
      //   // 方向角度值
      //   heading: 0,
      // };
      // setTimeout(() => {
      //   this.showCharts = true;
      // }, 5000);
      // map.flyToExtent(extent, options);

      // var graphicLayer = new mars3d.layer.GraphicLayer();
      // map.addLayer(graphicLayer);
      // var primitive = new mars3d.graphic.BillboardPrimitive({
      //   position: new mars3d.LatLngPoint(94.906853, 29.70314, 1548.6),
      //   style: {
      //     image: "static/mapconfig/img/mark3.png",
      //     scale: 1,
      //     horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
      //     verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
      //     clampToGround: true,
      //     label: { text: "加拉" },
      //   },
      // });
      // graphicLayer.addGraphic(primitive);
      // var primitive = new mars3d.graphic.BillboardPrimitive({
      //   position: new mars3d.LatLngPoint(
      //     95.14473700000003,
      //     29.903488423438592,
      //     1548.6
      //   ),
      //   style: {
      //     image: "static/mapconfig/img/mark3.png",
      //     scale: 1,
      //     horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
      //     verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
      //     clampToGround: true,
      //     label: { text: "扎曲" },
      //   },
      // });
      // graphicLayer.addGraphic(primitive);
      // // options = this.getEchartsOption();
      // // options.clampToGround = true; //计算贴地高度
      // // var echartsLayer = new mars3d.layer.EchartsLayer(options);
      // // map.addLayer(echartsLayer);
    },
    // searchBook() {
    //   //ask 万姐
    //   const loading = this.$loading({
    //     lock: true,
    //     text: "Loading",
    //     spinner: "el-icon-loading",
    //     background: "rgba(0, 0, 0, 0.7)",
    //   });
    //   userapi
    //     .getRequest("/search/searchBook", {
    //       keyword: this.keyword,
    //       page: this.page,
    //       pageSize: this.pageSize,
    //     })
    //     .then((res) => {
    //       loading.close();
    //       var bookTableList = [];
    //       this.booksum = res.data.data.sum;
    //       if (res.data.data.sum > 0) {
    //         this.pagecount = res.data.data.sum;
    //         for (var a = 0; a < res.data.data.list.length; a++) {
    //           bookTableList.push({
    //             bookurl: res.data.data.list[a].name,
    //             book: res.data.data.list[a].name.substring(
    //               res.data.data.list[a].name.lastIndexOf("/") + 1
    //             ),
    //             filesize: res.data.data.list[a].filesize,
    //           });
    //         }
    //       }
    //       this.bookTableList = bookTableList;
    //       this.searchView = false;
    //       this.searchResult = true;
    //     });
    // },
    searchBook1() {
      //ask 万姐
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      userapi
        .getRequest("/api/searchBook1", {
          keyword: this.keyword,
          person: this.person,
          book: this.book,
          year: this.year,
          company: this.company,
          literature: this.literature,
          journal: this.journal,
          page: this.page,
          pageSize: this.pageSize,
          gjz: this.gjz,
        })
        .then((res) => {
          loading.close();
          var bookTableList = [];
          this.pagecount = res.data.data.count;
          this.seword = res.data.data.seword;
          for (var a = 0; a < res.data.data.list.length; a++) {
            bookTableList.push({
              bookurl: res.data.data.list[a].path,
              book: res.data.data.list[a].name.substring(
                res.data.data.list[a].name.lastIndexOf("/") + 1
              ),
              zuozhe: res.data.data.list[a].authors,
            });
          }
          this.bookTableList = bookTableList;
          this.searchView = false;
          this.searchResult = true;
        });
    },
    //add by zhouao 2023/7/3 start
    handleCommand(data) {
      if (data == "checkUser") {
        this.checkUser();
      } else if (data == "toLogin") {
        this.quitLogin();
      } else if (data == "password") {
        //修改密码
        this.checkpassword();
      }
    },
    editReport() {
      // 处理点击"编辑报告"菜单项的逻辑
    },

    quitLogin() {
      this.$confirm("退出登录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        userapi
          .quitLogin()
          .then((res) => {
            sessionStorage.setItem("token", null);
            this.$message({
              type: "success",
              message: "已登出",
            });
          })
          .then(() => {
            this.totoken = false;
            this.$router.push({ path: "/login" });
          });
      });
    },
    checkUser() {
      let token = sessionStorage.getItem("token");
      console.log(sessionStorage.getItem("token"));
      if (token == null || token == undefined || token == "") {
        this.$confirm("请先登录", "提示", {
          confirmButtonText: "去登录",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$router.push({ path: "/login" });
        });
      } else {
        userapi.getUserNameByToken().then((res) => {
          if (res.data.code == 200) {
            this.$confirm("当前用户:" + res.data.data, {
              type: "success",
            });
          } else {
            this.$confirm("请先登录", "提示", {
              confirmButtonText: "去登录",
              cancelButtonText: "取消",
              type: "warning",
            }).then(() => {
              this.$router.push({ path: "/login" });
            });
          }
        });
      }
    },

    // getUser(){
    //   userapi.getUserByToken().then((res)=>{
    //     if( res.data.code===200&&res.data.data.c_role==="1"){
    //      this.totoken=true
    //     }
    //   })
    // },
    //
    checkpassword() {
      let token = sessionStorage.getItem("token");
      if (
        token === null ||
        token === undefined ||
        token === "null" ||
        token === ""
      ) {
        this.$confirm("请先登录", "提示", {
          confirmButtonText: "去登录",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$router.push({ path: "/login" });
        });
      } else {
        this.dialogVisible = true;
      }
    },
    //修改密码
    dialogVisibleConfirm() {
      userapi
        .sevaPassword({
          c_mobile: md5(this.user.c_mobile),
          c_password: md5(this.user.c_password),
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.$notify.success(res.data.msg);
            this.dialogVisible = false;
            userapi
              .quitLogin()
              .then((res) => {
                sessionStorage.setItem("token", null);
                this.$message({
                  type: "success",
                  message: "已登出",
                });
              })
              .then(() => {
                this.$router.push({ path: "/login" });
              });
          } else {
            this.$notify.error(res.data.msg);
            this.dialogVisible = true;
          }
        });
    },

    handleClose() {
      this.dialogVisible = false;
    },

    isOnline() {
      let token = sessionStorage.getItem("token");
      if (token == null || token == undefined || token == "") {
        return false;
      } else {
        return true;
      }
    },
    //add by zhouao 2023/7/3 end
  },
};
</script>

<style lang="less" scoped>
@import url('../static/font/iconfont.css');

body {
  width: 100vw;
  height: 100vh;
  margin: 0 !important;
  padding: 0;
}

* {
  margin: 0;
  padding: 0;
}

.contnet {
  width: 100vw;
  height: 100vh;
  padding: 0;
  margin: 0;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue